<template lang="pug">
span
  .ad-container(v-if="randomAd" :style="{ backgroundImage: 'url(' + randomAd.photo + ')' }")
    h2.decorative-text Weekly Giveaway!
    h3 {{ randomAd.title }}
    p {{ randomAd.desc }}
    a.chip.chip-active(@click="showEnterModal = true" v-if="businesses.length" tag="a") Enter Giveaway

  modal-enter(@closedEnterModal="showEnterModal = false" v-if="showEnterModal === true")

</template>

<script>

import modalEnter from '@/components/modal-enter.vue'

export default {
  name: 'adFeatured',
  data () {
    return {
      activeAd: '',
      showEnterModal: false,
      reservee: '',
      phone: ''
    }
  },
  components: {
    modalEnter
  },
  computed: {
    businesses () {
      return this.$store.getters.giveaways
    },
    randomAd () {
      return this.businesses[0]
    }
  },
  created () {
    this.$store.dispatch('loadedGiveaways')
  }
}
</script>

<style scoped lang="stylus">
img
  width 275px
  height 135px
  min-height 135px
  min-width 175px
  border-radius 10px
  overflow hidden

p
  color white
  font-size medium 
  font-weight bold

h2
  position absolute
  left -5%
  top -5%
  z-index 999999999999999
  font-size 3em
  transform rotate(-15deg)
  color white
  letter-spacing 2px
  text-shadow 2px 2px 5px #000
  @media screen and (max-width: 500px)
    top -5%
    font-size 35px

h3  
  font-weight bold
  @media screen and (max-width: 500px)
    margin-top 85px
    font-size small

.btn
  font-size large
  color white

</style>
